<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {

  },
  // 测试
  mounted () {
    this.$router.beforeEach((to, from, next) => {
    console.log(to);
    next();
});
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue